import {Injectable} from '@angular/core';
import {DataCoreService} from '@dabnet-kamu/libs/ui';
import {TemDefterService} from '../ctl-tem-defter.service';
import {CURRENCY_FORMAT} from '../../../../constants/currency';

@Injectable()
export class Service {
  public currencyFormat = CURRENCY_FORMAT;

  constructor(
    private dataCoreService: DataCoreService,
    private service: TemDefterService
  ) {
  }

  getData(control: any) {
    const dataSource = this.dataCoreService.getOData(control.dlistMetadata.baseEntity);
    dataSource.select([]);
    const filterArr = [];
    filterArr.push(['Bakiye', '>', 0]);
    if (this.service.period)
      filterArr.push(['Donem', '=', this.service.period]);
    if (this.service.receiptDate)
      filterArr.push(['FisTarih', '<=', this.service.receiptDate]);
    if (this.service.accountCode)
      filterArr.push(['HesapKod', '=', this.service.accountCode]);
    if (this.service.corporateCode)
      filterArr.push(['KurumsalKod', '=', this.service.corporateCode]);
    if (this.service.personCode)
      filterArr.push(['KisiKod', '=', this.service.personCode]);
    if (this.service.controlCondition) {
      this.service.controlCondition.forEach((item: any) => {
        filterArr.push([item.conditionColName, item.conditionColSymbol, item.conditionColText]);

      });
    }
    dataSource.filter(filterArr);
    return dataSource;
  }

}
